import { Action } from '@ngrx/store';
import { TSparePartListInfoActionType } from './sparepart-list.models';
import {
  TFilterSelected,
  TREQUEST_DELETE_SPAREPART,
  TREQUEST_BULK_UPDATE_SPAREPART_REQUEST_STATUS,
  TRESPONSE_SPAREPART_LIST,
  TRESPONSE_SPAREPART_REQUEST_LIST,
  TListingFetchReason,
  TREQUEST_SPAREPART_REQUEST_LIST,
  TREQUEST_UPDATE_SPAREPART_THRESHOLD,
  TREQUEST_UPDATE_SPAREPART_CRITICAL,
  TREQUEST_UPDATE_SPAREPART,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export class GetSparePartListInfo implements Action {
  readonly type = TSparePartListInfoActionType.GetSparePartList;
  constructor(
    public fetchReason: TListingFetchReason,
    public selectedFilters: TFilterSelected[],
    public searchStrOpt?: string,
  ) {}
}
export class GetSparePartListInfoSuccess implements Action {
  readonly type = TSparePartListInfoActionType.GetSparePartListSuccess;
  constructor(public sparePartListRes: TRESPONSE_SPAREPART_LIST, public fetchReason: TListingFetchReason) {}
}

export class GetSparePartListInfoFailure implements Action {
  readonly type = TSparePartListInfoActionType.GetSparePartListFailure;
}

export class SetSparePartListPagination implements Action {
  readonly type = TSparePartListInfoActionType.SetSparePartListPagination;
  constructor(public pagination: TUserPaginationOption) {}
}

export class UpdateSparePart implements Action {
  readonly type = TSparePartListInfoActionType.UpdateSparePart;
  constructor(public updatedSparePart: TREQUEST_UPDATE_SPAREPART) {}
}

export class UpdateSparePartSuccess implements Action {
  readonly type = TSparePartListInfoActionType.UpdateSparePartSuccess;
}

export class UpdateSparePartFailure implements Action {
  readonly type = TSparePartListInfoActionType.UpdateSparePartFailure;
}

export class DeleteSpareParts implements Action {
  readonly type = TSparePartListInfoActionType.DeleteSpareParts;
  constructor(public sparePartIds: TREQUEST_DELETE_SPAREPART['sparePartIds']) {}
}

export class DeleteSparePartsSuccess implements Action {
  readonly type = TSparePartListInfoActionType.DeleteSparePartsSuccess;
}

export class DeleteSparePartsFailure implements Action {
  readonly type = TSparePartListInfoActionType.DeleteSparePartsFailure;
}

export class SetSparePartRequestPagination implements Action {
  readonly type = TSparePartListInfoActionType.SetSparePartRequestPagination;
  constructor(public pagination: TUserPaginationOption) {}
}

export class GetSparePartRequestListInfo implements Action {
  readonly type = TSparePartListInfoActionType.GetSparePartRequestList;
  constructor(
    public payload: Omit<TREQUEST_SPAREPART_REQUEST_LIST, 'page' | 'itemsPerPage'>,
    public fetchReason: TListingFetchReason,
  ) {}
}

export class GetSparePartRequestListInfoSuccess implements Action {
  readonly type = TSparePartListInfoActionType.GetSparePartRequestListSuccess;
  constructor(
    public sparePartRequestListRes: TRESPONSE_SPAREPART_REQUEST_LIST,
    public fetchReason: TListingFetchReason,
  ) {}
}

export class GetSparePartRequestListInfoFailure implements Action {
  readonly type = TSparePartListInfoActionType.GetSparePartRequestListFailure;
}

export class BulkUpdateSparePartRequestStatus implements Action {
  readonly type = TSparePartListInfoActionType.BulkUpdateSparePartRequestStatus;
  constructor(public updatedSparePartRequest: TREQUEST_BULK_UPDATE_SPAREPART_REQUEST_STATUS) {}
}

export class BulkUpdateSparePartRequestStatusSuccess implements Action {
  readonly type = TSparePartListInfoActionType.BulkUpdateSparePartRequestStatusSuccess;
}

export class BulkUpdateSparePartRequestStatusFailure implements Action {
  readonly type = TSparePartListInfoActionType.BulkUpdateSparePartRequestStatusFailure;
}

export class BulkUpdateSparePartThreshold implements Action {
  readonly type = TSparePartListInfoActionType.BulkUpdateSparePartThreshold;
  constructor(public updatedSparePart: TREQUEST_UPDATE_SPAREPART_THRESHOLD) {}
}

export class BulkUpdateSparePartThresholdSuccess implements Action {
  readonly type = TSparePartListInfoActionType.BulkUpdateSparePartThresholdSuccess;
}

export class BulkUpdateSparePartThresholdFailure implements Action {
  readonly type = TSparePartListInfoActionType.BulkUpdateSparePartThresholdFailure;
}

export class BulkUpdateSparePartCritical implements Action {
  readonly type = TSparePartListInfoActionType.BulkUpdateSparePartCritical;
  constructor(public updatedSparePart: TREQUEST_UPDATE_SPAREPART_CRITICAL) {}
}

export class BulkUpdateSparePartCriticalSuccess implements Action {
  readonly type = TSparePartListInfoActionType.BulkUpdateSparePartCriticalSuccess;
}

export class BulkUpdateSparePartCriticalFailure implements Action {
  readonly type = TSparePartListInfoActionType.BulkUpdateSparePartCriticalFailure;
}

export type TSparePartListActions =
  | SetSparePartListPagination
  | GetSparePartListInfo
  | GetSparePartListInfoSuccess
  | GetSparePartListInfoFailure
  | UpdateSparePart
  | UpdateSparePartSuccess
  | UpdateSparePartFailure
  | DeleteSpareParts
  | DeleteSparePartsSuccess
  | DeleteSparePartsFailure
  | SetSparePartRequestPagination
  | GetSparePartRequestListInfo
  | GetSparePartRequestListInfoSuccess
  | GetSparePartRequestListInfoFailure
  | BulkUpdateSparePartRequestStatus
  | BulkUpdateSparePartRequestStatusSuccess
  | BulkUpdateSparePartRequestStatusFailure
  | BulkUpdateSparePartThreshold
  | BulkUpdateSparePartThresholdSuccess
  | BulkUpdateSparePartThresholdFailure
  | BulkUpdateSparePartCritical
  | BulkUpdateSparePartCriticalSuccess
  | BulkUpdateSparePartCriticalFailure;
